import { render, staticRenderFns } from "./HandShakeIcon.vue?vue&type=template&id=60332213&"
import script from "./HandShakeIcon.vue?vue&type=script&lang=js&"
export * from "./HandShakeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports